<div class="countFrame">
  <span>{{ controlName }}</span>
  <div class="btnContainer">
    <div
      class="minus-btn"
      [class.disabled]="disabled"
      (click)="decrementControl()"
    >
      |
    </div>
    <input type="number" disabled [(ngModel)]="count" />
    <div
      class="add-btn"
      [class.disabled]="disabled"
      (click)="incrementControl()"
    >
      +
    </div>
  </div>
</div>
